/* eslint-disable  no-underscore-dangle */
import { find, first, identity, isEmpty, omitBy } from 'lodash';
import { i18n } from '@lingui/core';

export default function getOptionFilterStateServiceFactory(title, options, paramName, paramTransform = identity) {
    return (filterId) => ({
        /*
         * Factory functions
         */
        createWithEncodedState(encodedState) {
            return encodedState;
        },

        createWithDefaultState() {
            return first(options)?.value;
        },

        createState(encodedFilterState, dataService) {
            const encodedState = encodedFilterState?.[filterId];
            return encodedState
                ? this.createWithEncodedState(encodedState, dataService)
                : this.createWithDefaultState(dataService);
        },

        /*
         * Transformation functions
         */
        parameterize(state) {
            return omitBy(
                {
                    [paramName]: paramTransform(state),
                },
                isEmpty
            );
        },

        encode(state) {
            return state;
        },

        summarize(state) {
            const option = find(options, (anOption) => anOption.value === state);
            return {
                title,
                value: i18n._(option?.name),
                shortValue: i18n._(option?.name),
            };
        },
    });
}
